if (document.querySelector("#js-tack-commanddirectory")) {
  import("./tackcommands/index.jsx").then(() => {});
}

if (document.querySelector("#js-glossary")) {
  import("./glossary/index.jsx").then(() => {});
}
